import { SHOW_MODAL } from './types';

export const showModal = data => {
  return {
    type: SHOW_MODAL,
    payload: data
  };
};
